<style lang="scss" scoped>
.custom-background {
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: cover;
  pointer-events: none;
}
.wgback {
  top: 0;
  img {
    width: 100%;
    height: 100%;
    // opacity: 0.2;
  }
}
.shade {
  top: 0;
  background-image: url("../../assets/public/shade.png");
}
.leftBorder {
  width: 37px;
  height: 998px;
  left: 47px;
  top: 51px;
  background-image: url("../../assets/public/left-border.png");
}
.topBorder {
  width: 1463px;
  height: 71px;
  left: 414px;
  top: 45px;
  background-image: url("../../assets/public/top-border.png");
}
.logo {
  width: 283px;
  height: 89px;
  left: 101px;
  top: 28px;
  background-image: url("../../assets/public/logo.png");
}
.bottomBorder {
  width: 1793px;
  height: 33px;
  left: 84px;
  bottom: 24px;
  background-image: url("../../assets/public/bottom-border-return.png");
}
.custom-time {
  position: absolute;
  display: flex;
  align-items: center;
  // width: 200px;
  height: 50px;
  top: 48px;
  right: 72px;
  color: #fff;
  font-weight: 500;
  font-size: 19px;
  line-height: 32px;
  // background-color: aqua;
  .date {
    width: 200px;
  }
  .wea-img {
    width: 47px;
    height: 38.19px;
    // margin-left: 14px;
    margin-right: 7px;
    line-height: 38.19px;
    // img {
    //   width: 100%;
    //   height: 100%;
    // }
  }
}
.onlyReturn,
.waterPumpBtn {
  pointer-events: all;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color: #ffffff;
  position: absolute;
  left: 798px;
  top: 8px;
}
.onlyReturn {
  width: 221px;
  text-align: center;
  height: 27px;
  cursor: pointer;
}
.waterPumpBtn {
  width: 221px;
  display: flex;
  justify-content: space-between;
  .returnScence {
    cursor: pointer;
  }
}
</style>

<template>
  <div>
    <div class="custom-background shade"></div>
    <div class="custom-background wgback">
      <img src="@/assets/public/background-line.svg" alt="" />
    </div>
    <div class="custom-background leftBorder"></div>
    <div class="custom-background logo"></div>
    <div class="custom-background topBorder"></div>
    <div class="custom-time">
      <div class="date">{{ dateInfo }}</div>
      <div class="wea-img">
        <!-- <img src="@/assets/public/small-rain.png" alt="" /> -->
        <div>{{ weather }}</div>
      </div>
      <div>{{ temp }}℃</div>
    </div>
    <div class="custom-background bottomBorder">
      <div class="onlyReturn" @click="returnEvent">返回</div>
    </div>
  </div>
</template>

<script>
import monent from "moment";
import { getHomePageData } from "@/api/index";
import bus from "@/components/three-scene/Bus.js";
export default {
  name: "custom-dereturn",
  data() {
    return {
      dateInfo: "",
      weather: "-",
      temp: "-",
      intv: null,
    };
  },
  created() {
    this.autoLoadTime();
    this.ReqHomePageData();
  },
  methods: {
    returnEvent() {
      this.$emit("returnEvent");
      bus.emit('initDom')
      bus.emit('initDom1')
    },
    autoLoadTime() {
      this.dateInfo = new monent().format("yyyy-MM-DD HH:mm:ss");
      this.intv = setInterval(() => {
        this.dateInfo = new monent().format("yyyy-MM-DD HH:mm:ss");
      }, 1000);
    },
    async ReqHomePageData() {
      let { data: res } = await getHomePageData();
      // console.log(res);
      if (res) {
        this.weather = res.weather;
        this.temp = res.temperature;
      }
    },
  },
  destroyed() {
    clearInterval(this.intv);
    this.intv = null;
  },
};
</script>
